import { get_config } from './api'
import Vue from 'vue'
import Router from './router'
import Store from './vuex/store'

export function app_config() {
    
    let token = ''
    
    // token as querystring
    if(Router.history.current.query.token) token = Router.history.current.query.token
 
    // token as state key
    if (token == '') token = Store.state.token
    
    Store.commit('set_token', { token: token })

    return get_config(token)
        .then((value) => {
            Vue.prototype.$config = value
            //Store.replaceState({})

            if (!value) return

            Store.commit('set_token', { token: value.token })  // per essere sicuri di usare il token che c'è in config
        })
}